import { render } from "./FooterLayout.vue?vue&type=template&id=ec41e3a2&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import "./FooterLayout.vue?vue&type=style&index=0&id=ec41e3a2&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec41e3a2"]])

export default __exports__